module.exports = __webpack_public_path__ + "img/bar3.8bcdcc79.png";